export default __webpack_public_path__ + "static/media/gallery-wip-crystal-holder_00.fc15c2b2.jpg";